import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './slide-show.css';

const Slideshow = ({ 
  images, 
  autoPlay = true, 
  showArrows = true, 
  showDots = true, 
  showButton = true,
  interval = 5000,
  transition = 'fade'
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(autoPlay);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    let timer;
    if (isPlaying) {
      timer = setTimeout(goToNext, interval);
    }
    return () => clearTimeout(timer);
  }, [currentIndex, isPlaying]);

  const togglePlay = () => {
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="slideshow-container">
      <div 
        className={`slideshow-slides transition-${transition}`}
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {images.map((image, index) => (
          <div 
            key={index} 
            className={`slideshow-slide ${index === currentIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
      </div>

      {showArrows && (
        <>
          <button className="slideshow-arrow prev" onClick={goToPrev}>
            &#10094;
          </button>
          <button className="slideshow-arrow next" onClick={goToNext}>
            &#10095;
          </button>
        </>
      )}

      {showDots && (
        <div className="slideshow-dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`slideshow-dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      )}

      {showButton && 
        <button className="slideshow-play-pause" onClick={togglePlay}>
            {isPlaying ? '❚❚' : '►'}
        </button>
      }
    </div>
    
  );
};

Slideshow.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  autoPlay: PropTypes.bool,
  showArrows: PropTypes.bool,
  showButton: PropTypes.bool,
  showDots: PropTypes.bool,
  interval: PropTypes.number,
  transition: PropTypes.oneOf(['fade', 'slide', 'zoom'])
};

export default Slideshow;
